'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAssignmentTurnedIn = function MdAssignmentTurnedIn(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.6 28.4l13.4-13.4-2.3-2.3-11.1 10.9-4.3-4.3-2.3 2.3z m3.4-23.4q-0.7 0-1.2 0.5t-0.4 1.1 0.4 1.3 1.2 0.5 1.2-0.5 0.4-1.3-0.4-1.1-1.2-0.5z m11.6 0q1.4 0 2.4 1t1 2.4v23.2q0 1.4-1 2.4t-2.4 1h-23.2q-1.4 0-2.4-1t-1-2.4v-23.2q0-1.4 1-2.4t2.4-1h6.9q0.6-1.5 1.8-2.4t2.9-1 2.9 1 1.8 2.4h6.9z' })
        )
    );
};

exports.default = MdAssignmentTurnedIn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/assignment-turned-in.js
// module id = 1263
// module chunks = 168707334958949